import * as React from 'react';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import * as redux from '../../../redux/constanst/index';
import { connect, useDispatch } from 'react-redux';

import {
  TransferContain

} from '../InicioFunctions/inicioElements';
import { llamadasEntrantes, llamadasErrores, llamadasSalientes, mapStateToProps } from '../models/buscar';
import LoadScreen from '../loadScreen';






function TransferList(props, list) {
  const dispatch = useDispatch();

  const [checked] = React.useState([]);
  const [right, setRight] = React.useState([]);
  const [load, setLoad] = React.useState(true)

  const [openLoad, setOpenLoad] = React.useState(false);

  const pushAnexos = (e) => {

    if (load === true) {
      const anexos = e;
      var arr = Object.values(anexos);
      setRight(arr)
      if (arr.length !== 0) {
        setLoad(false)
      }
    }

  }


  React.useEffect(() => {
    if (Object.values(right).length !== Object.values(props.rightAnexos).length) {/* 
      dispatch({ type: redux.USER_RIGHTANEXOS_STATE_CHANGE, rightAnexos: right }) */

      pushAnexos(props.rightAnexos);
    }


  })


  const handlerSearch = async ( diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos) => {
    
    const errores =  llamadasErrores("nada", 0, diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos);
    if((typeof errores) === "string"){
      dispatch({ type: redux.USER_ERRORSTATE_STATE_CHANGE, errorState: errores })
      dispatch({ type: redux.USER_LOADERROR_STATE_CHANGE, loadError: true })
      
    }
    if(errores === 200){
      setOpenLoad(true);
      const respEntrantes = await llamadasEntrantes("entrantes", 0, diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos);
      const respSalientes = await llamadasSalientes("salientes", 0, diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos);
      if(respSalientes?.type === "SQL" || respEntrantes?.type === "SQL" ){
        handlerSearch(diaInicio, mesInicio, diaFinal, mesFinal, yearInicio, yearFinal, anexos)
        return
      }
      await dispatch({ type: redux.USER_SALIENTES_STATE_CHANGE, salientes: respSalientes })
      
      await dispatch({ type: redux.USER_ENTRANTES_STATE_CHANGE, entrantes: respEntrantes })
      setOpenLoad(false);
    }
  
    
  
  }


  const handleToggleL = (value, event) => {
    const currentIndex = props.leftAnexos.indexOf(value);

    if (!props.rightAnexos.includes(value)) {
      dispatch({ type: redux.USER_SALIENTES_STATE_CHANGE, salientes: [] })
      dispatch({ type: redux.USER_ENTRANTES_STATE_CHANGE, entrantes: [] })
      dispatch({ type: redux.USER_RIGHTANEXOS_STATE_CHANGE, rightAnexos: props.rightAnexos.concat(value).sort() })
      dispatch({ type: redux.USER_LEFTANEXOS_STATE_CHANGE, leftAnexos: props.leftAnexos.splice(currentIndex, 1).sort() })
    }
    dispatch({ type: redux.USER_LEFTANEXOS_STATE_CHANGE, leftAnexos: props.leftAnexos })
    handlerSearch(props.dateChangeInicio.dia, props.dateChangeInicio.mes, props.dateChangeFinal.dia, props.dateChangeFinal.mes, props.dateChangeInicio.year, props.dateChangeFinal.year, Object.values(props.rightAnexos) )
  };

  const handleToggleR = (value) => {
    if (!props.leftAnexos.includes(value)) {
      dispatch({ type: redux.USER_SALIENTES_STATE_CHANGE, salientes: [] })
      dispatch({ type: redux.USER_ENTRANTES_STATE_CHANGE, entrantes: [] })
      const currentIndex = props.rightAnexos.indexOf(value);
      dispatch({ type: redux.USER_LEFTANEXOS_STATE_CHANGE, leftAnexos: props.leftAnexos.concat(value).sort() })
      dispatch({ type: redux.USER_RIGHTANEXOS_STATE_CHANGE, rightAnexos: props.rightAnexos.splice(currentIndex, 1).sort()  })
    }
    dispatch({ type: redux.USER_RIGHTANEXOS_STATE_CHANGE, rightAnexos: props.rightAnexos })
    handlerSearch(props.dateChangeInicio.dia, props.dateChangeInicio.mes, props.dateChangeFinal.dia, props.dateChangeFinal.mes, props.dateChangeInicio.year, props.dateChangeFinal.year, Object.values(props.rightAnexos) )
  };


  const handleAllRight = () => {

    dispatch({ type: redux.USER_SALIENTES_STATE_CHANGE, salientes: [] })
    dispatch({ type: redux.USER_ENTRANTES_STATE_CHANGE, entrantes: [] })
    dispatch({ type: redux.USER_RIGHTANEXOS_STATE_CHANGE, rightAnexos: props.leftAnexos.concat(props.rightAnexos).sort() })
    dispatch({ type: redux.USER_LEFTANEXOS_STATE_CHANGE, leftAnexos: [] })
  };




  const handleAllLeft = async () => {
    dispatch({ type: redux.USER_SALIENTES_STATE_CHANGE, salientes: [] })
    dispatch({ type: redux.USER_ENTRANTES_STATE_CHANGE, entrantes: [] })
    dispatch({ type: redux.USER_LEFTANEXOS_STATE_CHANGE, leftAnexos: props.rightAnexos.concat(props.leftAnexos).sort() })
    dispatch({ type: redux.USER_RIGHTANEXOS_STATE_CHANGE, rightAnexos: [] })
  };

  const customListL = (items) => (
    <TransferContain >
      <List dense component="div" role="list" style={{ width: '100%', maxWidth: 400, padding: 10 }}>
        {items.map((value) => {
          const labelId = `transfer-list-item-${value}-label`;
          return (
            <ListItem
              key={value}
              role=""
              button
              onClick={() => handleToggleL(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    'aria-labelledby': labelId,
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={`${value}`} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </TransferContain >
  );


  
  const customListR = (items, medidas) => (
    <TransferContain >
      <List dense component="div" role="list" style={{ width: 800, maxWidth:800, medidas, padding: 10 }}>
        {items.map((value) => {
          const labelId = `transfer-list-item-${value}-label`;
          return (
            <ListItem
              key={value}
              role=""
              button
              onClick={() =>props.rightAnexos.length === 1 ? handleAllLeft() :  handleToggleR(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={props.rightAnexos.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    'aria-label': 'Checkbox demo',
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={`${value}`} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </TransferContain >
  );


  return (
    <Grid container spacing={0} columns={30} style={{
      justifyContent: "center",
      alignItems: "center", marginTop: 20,
      background: 'white'
    }}>
      <Grid item xs={3} style={{ maxWidth: 230, minWidth: 230, padding: 5, }}>

        <div>Extensiones</div>
        {customListL(props.leftAnexos)}
      </Grid>

      <Grid item xs={2}  style={{ maxWidth: 70, minWidth: 70, }}>
        <Grid container direction="column" alignItems="center" >
          <Button
            sx={{ my: 0.2 }}
            variant="outlined"
            size="small"
            onClick={handleAllRight}
            disabled={props.leftAnexos.length === 0}
            aria-label="move all right"
          >
            ≫
          </Button>
          {/*   <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label="move selected right"
          >
            &gt;
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label="move selected left"
          >
            &lt;
          </Button> */}
          <Button
            sx={{ my: 0.2 }}
            variant="outlined"
            size="small"
            onClick={handleAllLeft}
            disabled={props.rightAnexos.length === 0}
            aria-label="move all left"
          >
            ≪
          </Button>
        </Grid>
      </Grid>

      <Grid item xs={3} style={{ maxWidth: 230, minWidth: 230, padding: 5, }}>

      <LoadScreen setOpenLoad={setOpenLoad} openLoad={openLoad}  />
      <Grid item xs={4} style={{ minWidth: 350, padding: 10 }}>

        <div>Listas para filtrar</div>
        {customListR(props.rightAnexos)}
      </Grid>
      
    </Grid>
    </Grid>
  )
}




export default connect(mapStateToProps, null)(TransferList);